const mobileBreakpoint = 768;
let iScreenWidth = document.body.getBoundingClientRect().width;

initSlider();

function initSlider() {
  const sliders = document.querySelectorAll('.js-mobile-slider');
  let aFlickitySliders = [];

  function initFlickity(slider) {
    return new Flickity(slider, {
      cellAlign: 'left',
      wrapAround: true,
      prevNextButtons: false,
    });
  }

  for (let i = 0; i < sliders.length; i += 1) {
    const slider = sliders[i];
    if (iScreenWidth < mobileBreakpoint) {
      let oSlider = initFlickity(slider);
      aFlickitySliders.push(oSlider);
    }
  }

  window.addEventListener('resize', () => {
    iScreenWidth = document.body.getBoundingClientRect().width;

    for (let i = 0; i < sliders.length; i += 1) {
      const oSlider = sliders[i];
      const oFlickSlider = aFlickitySliders[i];
      if (iScreenWidth < mobileBreakpoint) {
        if (!oFlickSlider) {
          let createdFlickSlider = initFlickity(oSlider);
          aFlickitySliders.push(createdFlickSlider);
        }
      } else {
        if (oFlickSlider) {
          oFlickSlider.destroy();
          aFlickitySliders.splice(0, 1);
        }
      }
    }
  });
}

var ppp = 6; // Post per page
var pageNumber = 1;

function load_posts() {
  pageNumber++;
  var str =
    '&pageNumber=' + pageNumber + '&ppp=' + ppp + '&action=more_post_ajax';

  jQuery(document).ready(function ($) {
    $.ajax({
      type: 'POST',
      dataType: 'html',
      url: ajax_posts.ajaxurl,
      data: { pageNumber: pageNumber, ppp: ppp, action: 'more_post_ajax' },
      success: function (data) {
        var $data = $(data);
        if ($data.length) {
          $('#ajax-posts').append($data);
          // $('#more_posts').attr('disabled', false); // Uncomment this if you want to disable the button once all posts are loaded
          $('#more_posts').hide(); // This will hide the button once all posts have been loaded
        } else {
          $('#more_posts').attr('disabled', true);
        }
      },
      error: function (jqXHR, textStatus, errorThrown) {
        $loader.html(jqXHR + ' :: ' + textStatus + ' :: ' + errorThrown);
      },
    });
    return false;
  });
}

jQuery(document).ready(function ($) {
  $('#more_posts').on('click', function () {
    // When btn is pressed.
    $('#more_posts').attr('disabled', true); // Disable the button, temp.
    load_posts();
    // $(this).insertAfter('#ajax-posts'); // Move the 'Load More' button to the end of the the newly added posts.
    $(this).appendTo('#more_posts_button_location');
  });
});
